// extracted by mini-css-extract-plugin
module.exports = {"cart":"Cart_cart__TqPm8","withItems":"Cart_withItems__1Xjts","counter":"Cart_counter__K8mmt"};